import { render } from "./Drawing.vue?vue&type=template&id=4fd586fa"
import script from "./Drawing.vue?vue&type=script&lang=js"
export * from "./Drawing.vue?vue&type=script&lang=js"

import "./Drawing.vue?vue&type=style&index=0&id=4fd586fa&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__